module.exports = __webpack_public_path__ + "img/mobile/BetBar/logo@3x.png?0.0.53";